// نگاشت state فرم برگه بازرسی روی ساختار مدل VehicleInspection (بک‌اند)

import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export const CAR_PANELS = [
  { key: "frontBumper", label: "سپر جلو" },
  { key: "hood", label: "کاپوت" },
  { key: "roof", label: "سقف" },
  { key: "trunk", label: "درب صندوق" },
  { key: "rearBumper", label: "سپر عقب" },
  { key: "leftFrontFender", label: "گلگیر جلو چپ" },
  { key: "leftFrontDoor", label: "درب جلو چپ" },
  { key: "leftRearDoor", label: "درب عقب چپ" },
  { key: "leftRearFender", label: "گلگیر عقب چپ" },
  { key: "rightFrontFender", label: "گلگیر جلو راست" },
  { key: "rightFrontDoor", label: "درب جلو راست" },
  { key: "rightRearDoor", label: "درب عقب راست" },
  { key: "rightRearFender", label: "گلگیر عقب راست" },
];

export const PANEL_STATUS_OPTIONS = [
  { value: "healthy", label: "سالم" },
  { value: "painted", label: "رنگ‌شده" },
  { value: "replaced", label: "تعویض" },
  { value: "damaged", label: "ضربه‌خورده" },
];

// همه‌ی فرآیند توسط یک نفر (کارشناس/اپراتور) در یک صفحه تکمیل می‌شود.
// شماره فاکتور و تاریخ/ساعت اینجا نیستند چون قبل از ثبت وجود ندارند؛
// این دو بعد از ثبت، از روی _id و createdAt رکورد ساخته‌شده در بک‌اند نمایش داده می‌شوند.
export const INITIAL_INSPECTION_DATA = {
  // مشتری / مالک خودرو
  vehicleOwner: "",
  customerPhone: "",

  // خودرو
  vehicleName: "",
  vehicleModel: "",
  vehicleYear: "",
  vehicleColor: "",
  plateNumber: "",
  vin: "",
  engineNumber: "",

  // وضعیت بدنه
  carPanels: CAR_PANELS.reduce(
    (acc, panel) => ({ ...acc, [panel.key]: "healthy" }),
    {},
  ),

  description: "",
};

// تلفن مشتری در مدل بک‌اند فیلد جدا ندارد، پس داخل توضیحات ذخیره می‌شود
function buildFullDescription(data) {
  const metaLines = [
    data.customerPhone && `تلفن مشتری: ${data.customerPhone}`,
  ].filter(Boolean);

  if (metaLines.length === 0) return data.description || "";

  return [metaLines.join(" | "), data.description || ""]
    .filter(Boolean)
    .join("\n\n");
}

export function buildVehicleInspectionPayload(data) {
  return {
    vehicleOwner: data.vehicleOwner,
    vehicle: {
      name: data.vehicleName,
      model: data.vehicleModel,
      year: Number(data.vehicleYear) || undefined,
      color: data.vehicleColor,
      plateNumber: data.plateNumber,
      vin: data.vin,
      engineNumber: data.engineNumber,
    },
    carPanels: data.carPanels,
    description: buildFullDescription(data),
    // بازرسی برای همون شماره مشتری ارسال می‌شود
    sendInspectFor: data.customerPhone,
  };
}

// شماره فاکتور و تاریخ/ساعت را از رکورد ثبت‌شده (پاسخ بک‌اند) استخراج می‌کند:
// شماره فاکتور = _id ، تاریخ و ساعت = createdAt
export function formatInspectionMeta(inspection) {
  const invoiceNumber = inspection?._id || inspection?.id || "";
  const createdAt = inspection?.createdAt
    ? new Date(inspection.createdAt)
    : null;

  if (!createdAt) {
    return { invoiceNumber, date: "", time: "" };
  }

  const jalali = new DateObject({
    date: createdAt,
    calendar: persian,
    locale: persian_fa,
  });

  return {
    invoiceNumber,
    date: jalali.format("YYYY/MM/DD"),
    time: jalali.format("HH:mm"),
  };
}

// از description ذخیره‌شده، «تلفن مشتری» را جدا می‌کند تا در برگه‌ی چاپی
// در فیلد مخصوص خودش نمایش داده شود و توضیحات آزاد کاربر تنها متن باقی‌مانده باشد
export function parseInspectionDescription(description = "") {
  const match = (description || "").match(/^تلفن مشتری:\s*([^\n]+)/);
  if (!match) {
    return { customerPhone: "", notes: description || "" };
  }
  const notes = description.replace(/^تلفن مشتری:[^\n]*\n*/, "").trim();
  return { customerPhone: match[1].trim(), notes };
}
